export function parseTryCatchError(e: unknown, defaultMessage?: string) {
  if (e instanceof Error) {
    return e.message;
  } else return defaultMessage || 'Something went wrong';
}
